import { createContext, useContext } from "react";

const BannerContext = createContext(false);

export const BannerProvider = BannerContext.Provider;
export const useIsInBanner = () => useContext(BannerContext);
